import React from 'react';
import { useApp } from '../../context/AppContext';
import '../../styles/topbar.css';

const PAGE_META = {
  '/':            { title: 'Overview',          sub: 'Fleet summary across all operators' },
  '/fleet':       { title: 'Fleet Registry',    sub: 'Complete aircraft inventory and specifications' },
  '/utilisation': { title: 'Utilisation',       sub: 'Flight hours, cycles and operational intensity' },
  '/flights':     { title: 'Flights',           sub: 'Flight movements, routes and operator breakdown' },
  '/mro':         { title: 'MRO & Maintenance', sub: 'Maintenance events, facilities and downtime analysis' },
  '/risk':        { title: 'Lifecycle & Risk',  sub: 'Aircraft stability, lifecycle stages and concentration risk' },
  '/history':     { title: 'Operator History',  sub: 'Ownership and operator change history by MSN' },
};

export default function TopBar({ pathname }) {
  const { operator, setOperator, status, setStatus, OPERATORS, lessorMeta } = useApp();
  const meta = PAGE_META[pathname] || PAGE_META['/'];

  return (
    <div className="topbar">
      <div>
        <div className="page-title">{meta.title}</div>
        <div className="page-sub">{meta.sub}</div>
      </div>
      <div className="topbar-right">
        {lessorMeta.badge && (
          <div className="tb-badge">{lessorMeta.badge}</div>
        )}
        <div className="tb-div" />
        <select
          className="fsel"
          value={operator}
          onChange={e => setOperator(e.target.value)}
          style={{ height: 30 }}
        >
          <option value="">All Operators</option>
          {OPERATORS.map(op => <option key={op}>{op}</option>)}
        </select>
        <select
          className="fsel"
          value={status}
          onChange={e => setStatus(e.target.value)}
          style={{ height: 30 }}
        >
          <option value="">All Status</option>
          <option>Active</option>
          <option>Stored</option>
          <option>Maintenance</option>
          <option>On repair</option>
        </select>
      </div>
    </div>
  );
}
